import React from "react";

const ConfirmationStep = ({
  selectedDate,
  selectedSlot,
  selectedEventType,
  formatTime,
  setStep,
  handleBooking,
  loading,
}) => {
  return (
    <div className="p-5 flex-1">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => setStep(2)}
          className="text-primary hover:text-primary/80 font-medium"
        >
          ← Back to times
        </button>
        <h3 className="text-lg font-semibold">Confirm Your Booking</h3>
      </div>

      <div className="grid md:grid-cols-1 gap-4 mb-6">
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="font-semibold mb-3 text-base">Booking Details</h4>
          <div className="space-y-2">
            <p className="flex justify-between text-sm">
              <span className="font-medium">Date:</span>
              <span>{new Date(selectedDate).toLocaleDateString()}</span>
            </p>
            <p className="flex justify-between text-sm">
              <span className="font-medium">Time:</span>
              <span>{formatTime(selectedSlot.time)}</span>
            </p>
            <p className="flex justify-between text-sm">
              <span className="font-medium">Duration:</span>
              <span>{selectedEventType.length || 30} minutes</span>
            </p>
            <p className="flex justify-between text-sm">
              <span className="font-medium">Meeting Type:</span>
              <span>Video Call</span>
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleBooking}
          disabled={loading}
          className="px-6 py-3 bg-primary text-white rounded-full font-medium hover:bg-primary/90 disabled:opacity-50 transition-colors"
        >
          {loading ? "Booking..." : "Confirm Booking"}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationStep;
